import React, { useCallback, useContext, useEffect } from 'react';
import { T } from '@testout/labsim-ui-atomics';
import Styles from './retirement-notice.module.less';
import { StateContext } from '../services/LabSimService';
const RetirementNotice = () => {
    const stateContext = useContext(StateContext);
    useEffect(() => {
        const frame = requestAnimationFrame(() => {
            const element = document.querySelector('#close-overlay');
            if (element instanceof HTMLElement)
                element.style.position = 'fixed';
        });
        return () => cancelAnimationFrame(frame);
    }, []);
    const onClose = useCallback(() => {
        stateContext.setShowRetirementNotice(false);
    }, [stateContext]);
    return (React.createElement(T.Dialog, { automationId: 'retirement-notice-dialog', className: Styles.retirementNotice, onClose: onClose },
        React.createElement(T.Dialog.Header, { className: Styles.noPadding },
            React.createElement(T.Dialog.TitleBar, { className: Styles.noPadding },
                React.createElement(T.Dialog.Title, { className: Styles.noPadding }),
                React.createElement(T.Dialog.TitleBar.Actions, { position: 'right' },
                    React.createElement(T.Dialog.CloseButton, { id: 'close-overlay', className: Styles.retirementClose })))),
        React.createElement("div", { className: Styles.retirementNoticeContent, dangerouslySetInnerHTML: {
                __html: `<html lang="en">

                <head>
                    <meta charset="utf-8">
                    <title>CompTIA Inbox Message</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1">
                    <!--use Google fonts-->
                    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans">
                    <style>
                    /* Note on CSS conventions: All welcome message class names start with wm- to avoid interference with other LabSim CSS classes */
                    /* General            ------------------------*/
                    * {
                        box-sizing: border-box;
                    }

                    /* Color variables and classes           ------------------------*/
                    :root {
                        --gray-lightest: #F9FAFB;
                        /* light gray background color */
                        --gray-light: #D4D8DA;
                        /* border color */
                        --gray-darkest: #191D1F;
                        /* dark text color */
                        --blue: #217097;
                        /* link and button color */
                        --blue-dark: #18516D;
                        /* button hover color */
                    }

                    .wm-gray-darkest {
                        color: var(--gray-darkest);
                    }

                    .wm-white {
                        color: white;
                    }

                    /* Body           ------------------------*/
                    body {
                        margin: 0;
                        font-family: 'Noto Sans', sans-serif;
                        color: var(--gray-darkest);
                        line-height: 1.5;
                        font-size: .875rem;
                    }

                    body,
                    html {
                        padding: 0;
                    }

                    /* Typography           ------------------------*/
                    a {
                        color: var(--blue);
                        text-decoration: none;
                    }

                    a:hover,
                    a:active,
                    a:focus-visible {
                        text-decoration: underline;
                    }

                    .wm-h1 {
                        font-size: 2rem;
                        margin: 0 0 1rem;
                        text-align: center;
                    }

                    .wm-h2 {
                        font-size: 1.625rem;
                        margin: 0 0 1rem;
                    }

                    .wm-p {
                        font-size: .875rem;
                        margin: 1em 0;
                    }

                    .wm-bold {
                        font-weight: 700;
                    }

                    /* use to make font bold */
                    .wm-normal {
                        font-weight: 400;
                    }

                    /* use to make bold text normal weight instead */
                    .wm-left {
                        text-align: left;
                    }

                    /* use to align text left */
                    .wm-center {
                        text-align: center;
                    }

                    /* use to align text center */
                    .wm-right {
                        text-align: right;
                    }

                    /* use to align text right */
                    .wm-caps {
                        text-transform: uppercase;
                    }

                    /* use to make text all caps */
                    /* Layout           ------------------------*/
                    /* .wm-wrap defines the width */
                    .wm-wrap {
                        width: 580px;
                        border-top: .5rem solid var(--blue);
                        border-bottom: .5rem solid var(--blue);
                        padding: 2rem;
                    }

                    /* .wm-divider is a yellow horizontal line used to separate lines of text; to use this, create an empty div, and give it this class */
                    .wm-divider {
                        border: 2px solid var(--blue);
                        margin: 1rem auto;
                        width: 6rem;
                    }

                    /* Button           ------------------------*/
                    .wm-button {
                        display: flex;
                        font-size: 1rem;
                        text-align: center;
                        justify-content: center;
                        align-items: center;
                        height: 3rem;
                        font-weight: 700;
                        width: 16rem;
                        padding: 0 1rem;
                        background: var(--blue);
                        color: white !important;
                        /* overrides the link color for dark theme */
                        transition: background .2s;
                        border-radius: 4px;
                        margin: 2rem auto;
                        text-decoration: none;
                        outline: 2px solid transparent;
                        outline-offset: -2px;
                    }

                    .wm-button:hover,
                    .wm-button:active {
                        background: var(--blue-dark);
                        text-decoration: none;
                    }

                    .wm-button:focus-visible {
                        outline-color: var(--blue);
                        box-shadow: 0 0 0 4px white inset;
                        text-decoration: none;
                    }

                    /* Images           ------------------------*/
                    img {
                        max-width: 100%;
                        display: block;
                        margin: 1rem auto;
                    }

                    .wm-logo {
                        margin: 0 auto 2rem;
                        height: 3rem;
                        box-shadow: none;
                    }
                    </style>
                </head>

                <body>
                    <div class="wm-wrap"> <img class="wm-logo" src="https://hs.testout.com/hubfs/CompTIA%20logo%20SVG.svg" alt="CompTIA logo">
                        <h1 class="wm-h1">Retirement Notice</h1>
                        <div class="wm-divider"></div>
                        <h2 class="wm-h2 wm-center">The EduApp/Plugin LMS integration will be retired on 7/1/2025</h2>
                        <p class="wm-p">As the retirement date approaches, we encourage you to update to the latest LMS integration technology, LTI 1.3 Advantage. This upgrade will ensure uninterrupted access and functionality.</p>
                        <p>Important Details:</p>
                        <ul>
                            <li>Existing classes will remain unaffected and allowed to finish out their course.</li>
                            <li>For future classes, please create a new class using the newest integration.</li>
                        </ul>
                        <p>If you need assistance with updating to the newest integration or have any questions about the updated course, please contact your account representative.</p>
                        <a href="https://help.comptia.org/hc/en-us/articles/24142560245396-LTI-1-1-to-1-3-Transition-for-CertMaster-formerly-TestOut-LabSim" target="_blank" class="wm-button">Get Started</a>
                    </div>
                </body>

                </html>`,
            } })));
};
export default RetirementNotice;
//# sourceMappingURL=retirement-notice.dialog.js.map